import { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios'
import { encodeSHA256 } from '../../apis/config/utils'

const AUTH_KEY_SECRET = process.env.AUTH_KEY_SECRET

export function basicRequestInterceptor(config: AxiosRequestConfig<any>) {
  const timestamp = Date.now()
  const token = encodeSHA256(timestamp, AUTH_KEY_SECRET as string)
  config.headers = {
    timestamp: `${timestamp}`,
    Authorization: `${token}`
  }
  return config as InternalAxiosRequestConfig
}
